export enum Routes {
  ChatVideo = '/rooms/:roomId',
  ShiftManagement = '/shift-management',
  Login = '/login',
  ChatVideoLog = '/rooms/:roomId/log',
}
